import { InjectionToken } from '@angular/core';

export const RECEIPT_SCANNER = 'receipt-scanner';
export const SCANNER_ROUTE = 'scanner';
export const RECEIPTS_ROUTE = 'receipts';
export const SCANNING_ROUTE = 'scanning';
export const ABOUT_ROUTE = 'about';
export const ID_ROUTE_PARAM = 'id';
export const NO_ACCESS = 'no-access';

export const RECEIPT_IMAGE_ROUTE = 'receipt-image';

export const ABOUT_SCANNER_PAGE_SEEN_LOCAL_STORAGE_KEY = 'about-scanner-page-seen';

export const RECEIPT_SCANNER_BASE_PATH = new InjectionToken<string>('RECEIPT_SCANNER_BASE_PATH', {
  providedIn: 'root',
  factory: (): string => RECEIPT_SCANNER,
});
